import React, { useEffect, useState } from "react";
import { leaderboardStyles as styles } from "./leaderboardStyles.tailwind";
import LeaderboardInfo from './LeaderboardInfo';
import { useSelector } from "react-redux";
import no_leaderboard from '../../../../../../assets/svgs/no_leaderboard_details.svg';
import expand_leaderboard from '../../../../../../assets/svgs/expand_leaderboard.svg';
import ExpandedLeaderboardModal from "../../../../../shared/Modals/ExpandedLeaderboard/ExpandedLeaderboard";
import { KeyboardArrowDownRounded, KeyboardArrowUpRounded } from "@mui/icons-material";
import LeaderBoardSkeleton from "../../../../shared/Skeletons/LeaderBoardSkeleton/LeaderBoardSkeleton";

const Leaderboard = ({ gameId }) => {
  const { leaderboardDetails, leaderboardLoading } = useSelector(state => state.liveGame);
  const leaderboardData = leaderboardDetails?.leaderboard || [];

  const [openLeaderboardModal, setOpenLeaderboardModal] = useState(false);
  const [minimizeLeaderboard, setMinimizeLeaderboard] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Reset minimize state if screen is >= 1024px (lg)
      if (window.innerWidth >= 1024) {
        setMinimizeLeaderboard(false);
      }
    };

    // Initial check
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // {/* Game Leaderboard Section */}
    <div className={styles.leaderboard}>
      {/* Section Title */}
      <div className="relative">
        <h1 className={styles.sectionTitle}>Game Leaderboard</h1>

        <div className="absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center gap-2">
          {leaderboardData && leaderboardData?.length > 0 && (
            <button onClick={() => setOpenLeaderboardModal(true)}>
              <img src={expand_leaderboard} alt="" className="max-w-[15px] screen-500:max-w-[20px]" />
            </button>
          )}

          <button className="flex lg:hidden" onClick={() => setMinimizeLeaderboard(prev => !prev)}>
            {
              minimizeLeaderboard ? (
                <KeyboardArrowDownRounded />
              ) : (
                <KeyboardArrowUpRounded />
              )
            }
          </button>
        </div>
      </div>

      {leaderboardLoading && (
        <div className="px-[10px] py-2">
          <LeaderBoardSkeleton count={4} />
        </div>
      )}

      {!minimizeLeaderboard && !leaderboardLoading && (
        <>
          {(!leaderboardData || leaderboardData?.length === 0) ? (
            <div className='flex flex-col items-center justify-center h-full pb-2 gap-1 screen-500:h-[unset] justify-[unset]'>
              <img src={no_leaderboard} alt="" className={styles.no_leaderboard} />
              <p className={styles.no_leaderboard_text}>No Points are awarded yet.</p>
            </div>
          ) : (
            <div className={styles.leaderboardContainer}>
              <div className={styles.headers}>
                <LeaderboardInfo playerData={leaderboardData} />
              </div>
            </div>
          )}
        </>
      )}

      {openLeaderboardModal && (
        <ExpandedLeaderboardModal
          gameId={gameId}
          isOpen={openLeaderboardModal}
          onClose={() => setOpenLeaderboardModal(false)}
        />
      )}
    </div>
  );
};

export default Leaderboard;
